<script lang="ts">
  import ArrowButton from '$lib/components/serviceButton/ArrowButton.svelte'
  import ResourceCard from '$lib/components/card/ResourceCard.svelte'
  import CardListWrapper from '$lib/wrappers/CardListWrapper.svelte'
  import { pageHrefs } from '$lib/constants/breadCrumbConstants'
  import type { LandingPageBase, LoadResult, ServiceAreaElement } from '$lib/types/ServicePageTypes'
  import { _ } from 'svelte-i18n'
  import GeneralSectionWrapper from '$lib/wrappers/GeneralSectionWrapper.svelte'
  import H1 from '$lib/components/typography/H1.svelte'
  import H4 from '$lib/components/typography/H4.svelte'
  import Body from '$lib/components/typography/Body.svelte'
  import { page } from '$app/stores'
  import PrimaryArrowButton from '$lib/components/serviceButton/PrimaryArrowButton.svelte'
  import SEO from '$lib/components/seo/SEO.svelte'
  import Trening from '$lib/components/icons/largeIcons/Trening.svelte'
  import LocationButtonMenu from '$lib/components/locationButtonMenu/LocationButtonMenu.svelte'
  import CtaSection from '$lib/components/cta/CtaSection.svelte'
  import Resources from '$lib/components/landingPage/Resources.svelte'
  import { CtaDoubleSection } from '$lib/components/cta'
  import LandingPageFaqWrapper from '$lib/components/article/LandingPageFaqWrapper.svelte'
  import logoStore from '$lib/stores/logoStore'
  import { onDestroy } from 'svelte'

  const user = $page.data.session?.user

  type LandingPages = {
    [key: string]: LandingPageBase
  }

  export let data: LoadResult<{
    landingPages: LandingPageBase[]
    serviceAreaElements: ServiceAreaElement[]
  }>
  const { landingPages, serviceAreaElements } = data.props
  let elementCount = 0
  $: elementCount = serviceAreaElements
    ? serviceAreaElements.filter((element) => element.location == activeId).length
    : 0
  const landingPagesByLocation = landingPages.reduce((acc: LandingPages, value: LandingPageBase) => {
    return value.location !== 'felles'
      ? {
          ...acc,
          [value.location]: value,
        }
      : acc
  }, {})

  const userLocation = user?.location || 'bergen'
  $: activeId = $page.url.searchParams.get('location') || userLocation || 'bergen'
  $: logoStore.set(activeId)
  $: ({ title, ingress, resources, seo, ctaSection1, ctaSection2, relevantFaqs, ctaSectionDouble } =
    landingPagesByLocation[activeId])

  onDestroy(() => {
    logoStore.clear()
  })
</script>

<SEO title={seo?.metaTitle || title} description={seo?.metaDescription || ingress} />
<GeneralSectionWrapper class="bg-primary-50 !pb-0">
  <LocationButtonMenu {activeId} />
</GeneralSectionWrapper>
<GeneralSectionWrapper class="bg-primary-50 !py-0">
  <Trening />
  <H1 class="text-gray-800 pb-4">{title}</H1>
  {#if ingress}
    <H4 class="text-base-black pb-8">{ingress}</H4>
  {/if}
  {#if activeId === 'bergen'}
    <div class="flex md:flex-row flex-col gap-6">
      <PrimaryArrowButton
        justifyCenter
        href={pageHrefs.bliMedlem()}
        width="w-full md:w-44 md:min-w-fit"
        withIcon={false}
      >
        <Body class="text-base-white">{$_('trening.linkButtons.enrollBergen')}</Body>
      </PrimaryArrowButton>
    </div>
  {/if}
</GeneralSectionWrapper>
{#if activeId === 'bergen'}
  <GeneralSectionWrapper class="bg-primary-50">
    <div class="flex flex-col md:flex-row md:flex-wrap gap-8 justify-between">
      <ArrowButton
        href=" https://sammen.ibooking.no/webapp/timeplan/?type=groupclasses"
        width="w-full md:w-60"
        target="_blank"
        >{$_('trening.linkButtons.groupLesson')}
      </ArrowButton>
      <ArrowButton href={`${pageHrefs.kurs()}?category=Trening`} width="w-full md:w-60"
        >{$_('trening.linkButtons.courses')}</ArrowButton
      >
      <ArrowButton href={pageHrefs.aaapningstider()} width="w-full md:w-60"
        >{$_('trening.linkButtons.openingHours')}</ArrowButton
      >
      <ArrowButton href="https://sammen.ibooking.no/minside/" width="w-full md:w-60" target="_blank"
        >{$_('trening.linkButtons.myPageTraining')}</ArrowButton
      >
    </div>
  </GeneralSectionWrapper>
{/if}
{#key ctaSectionDouble}
  <CtaDoubleSection {ctaSectionDouble} class="bg-base-white py-4 md:pb-8" />
{/key}
<CtaSection ctaSection={ctaSection1} />
<CtaSection ctaSection={ctaSection2} />
{#if serviceAreaElements && serviceAreaElements.length > 0 && elementCount > 0}
  <GeneralSectionWrapper class="bg-primary-50">
    <H1 class="text-primary-700">{$_('trening.herKanDuTrene')}</H1>
    <CardListWrapper>
      {#each serviceAreaElements as element}
        {#if element.location == activeId}
          <ResourceCard
            fitHeightToOuterDiv
            flexGrow={elementCount < 3 ? '' : 'flex-grow'}
            image={element.image}
            title={element.title}
            url={`${pageHrefs.senter()}/${element.slug}`}
            max={false}
          />
        {/if}
      {/each}
    </CardListWrapper>
  </GeneralSectionWrapper>
{/if}
<Resources {resources} pageHref={pageHrefs.treningressurser()} />
<LandingPageFaqWrapper {relevantFaqs} />
